/**
 * Get today's date in YYYY-MM-DD format
 * @returns {string} Today's date formatted as YYYY-MM-DD
 */
export const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Get a future date in YYYY-MM-DD format
 * @param {number} daysFromNow - Number of days to add to current date
 * @returns {string} Future date formatted as YYYY-MM-DD
 */
export const getFutureDate = (daysFromNow) => {
  const date = new Date();
  date.setDate(date.getDate() + daysFromNow);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Format a date string to YYYY-MM-DD
 * @param {Date|string} date - Date object or date string
 * @returns {string} Formatted date as YYYY-MM-DD
 */
export const formatDateToYYYYMMDD = (date) => {
  if (!date) return "";

  const dateObj = date instanceof Date ? date : new Date(date);

  if (isNaN(dateObj.getTime())) return "";

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Check if a date is in the past
 * @param {string} dateString - Date string in YYYY-MM-DD format
 * @returns {boolean} True if date is in the past
 */
export const isDateInPast = (dateString) => {
  if (!dateString) return false;

  const inputDate = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return inputDate < today;
};

/**
 * Check if a date is valid
 * @param {string} dateString - Date string to validate
 * @returns {boolean} True if date is valid
 */
export const isValidDate = (dateString) => {
  if (!dateString) return false;

  const date = new Date(dateString);
  return !isNaN(date.getTime());
};

/**
 * Get date range for validation (min and max dates)
 * @param {number} minDaysFromNow - Minimum days from now (default: 0 for today)
 * @param {number} maxDaysFromNow - Maximum days from now (default: 365 for 1 year)
 * @returns {object} Object with min and max dates in YYYY-MM-DD format
 */
export const getDateRange = (minDaysFromNow = 0, maxDaysFromNow = 365) => {
  return {
    min: getFutureDate(minDaysFromNow),
    max: getFutureDate(maxDaysFromNow),
  };
};
